// Shared owner pill (MUI Chip) used by the owner FILTER and the owners editor
// (interest detail, slideout and Owner column), so they stay visually in sync.
import React from "react";
import { Chip, ChipProps } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export type OwnerChipProps = {
  label: React.ReactNode;
  ariaLabel?: string;

  /** When provided, renders the CancelIcon delete affordance wired to this. */
  onDelete?: (event: React.SyntheticEvent) => void;
  deleteAriaLabel?: string;
  onClick?: () => void;

  /** Greys the chip out while a change to this owner is in flight. */
  disabled?: boolean;
  "data-testid"?: string;
  deleteTestId?: string;
  deleteDataCy?: string;
  "data-cy"?: string;

  /** Autocomplete value-chip wiring (from its getItemProps) for chip keyboard navigation. */
  className?: string;
  tabIndex?: number;
  "data-item-index"?: number;
};

const OwnerChip: React.FC<OwnerChipProps> = ({
  label,
  ariaLabel,
  onDelete,
  deleteAriaLabel = "Remove",
  onClick,
  disabled = false,
  deleteTestId,
  deleteDataCy,
  "data-testid": dataTestId,
  "data-cy": dataCy,
  className,
  tabIndex,
  "data-item-index": dataItemIndex,
}) => {
  // Only wire the delete affordance when onDelete is provided.
  const deleteProps: Partial<ChipProps> = {};
  if (onDelete) {
    deleteProps.onDelete = onDelete;
    deleteProps.deleteIcon = (
      <CancelIcon
        role="button"
        aria-hidden={false}
        aria-label={deleteAriaLabel}
        data-testid={deleteTestId}
        data-cy={deleteDataCy}
      />
    );
  }

  return (
    <Chip
      size="small"
      label={label}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      data-cy={dataCy}
      className={className}
      tabIndex={tabIndex}
      data-item-index={dataItemIndex}
      onClick={onClick}
      disabled={disabled}
      {...deleteProps}
    />
  );
};

export default OwnerChip;
